import { defaultAppSettings } from "./appSettingsService";
import { getCurrentRoleKey, normalizeRoleKey } from "./authService";

const getRoleDefinition = (settings = defaultAppSettings) => {
  const currentRole = getCurrentRoleKey();

  return (settings.roles || []).find((role) => {
    const normalizedId = normalizeRoleKey(role.id);
    const normalizedName = normalizeRoleKey(role.name);

    return normalizedId === currentRole || normalizedName === currentRole;
  });
};

export const hasPermission = (permission, settings = defaultAppSettings) => {
  if (!permission) {
    return true;
  }

  const currentRole = getCurrentRoleKey();
  // Super Admin has master CRUD authority across all permissions and modules
  if (currentRole === "super-admin") {
    return true;
  }

  return Boolean(getRoleDefinition(settings)?.restrictions?.[permission]);
};

export const hasRoleAccess = (allowedRoles = []) => {
  const currentRole = getCurrentRoleKey();
  // Super Admin has unrestricted role access across all pages and components
  if (currentRole === "super-admin") {
    return true;
  }

  if (!allowedRoles || allowedRoles.length === 0) {
    return true;
  }

  return allowedRoles
    .map((role) => normalizeRoleKey(role))
    .includes(currentRole);
};

export const canAccessItem = (item = {}, settings = defaultAppSettings) => {
  const currentRole = getCurrentRoleKey();
  // Super Admin can access all items, tabs, menus, and routes
  if (currentRole === "super-admin") {
    return true;
  }

  const checks = [];

  if (item.roles?.length) {
    checks.push(hasRoleAccess(item.roles));
  }

  if (item.permission) {
    checks.push(hasPermission(item.permission, settings));
  }

  if (checks.length === 0) {
    return true;
  }

  return checks.every(Boolean);
};
